/** @internal */
export class SessionDescription {
    public meta?: any;
    public sdp!: string;
    public type!: string;


    public static Load(x: any): SessionDescription {
        const sd = new SessionDescription();
        sd.sdp = x.sdp;
        sd.type = x.type;

        return sd;
    }

    public static Create(SessionDescription: RTCSessionDescription, meta: any = undefined): SessionDescription {
        return {
            meta: meta,
            sdp: SessionDescription.sdp,
            type: SessionDescription.type.toLowerCase(),
        } as SessionDescription;
    }

    public ToRTCSessionDescription(): RTCSessionDescription {
        return {
            sdp: this.sdp,
            type: this.type.toLowerCase(),
        } as RTCSessionDescription;
    }
}
